<template>
  <div>


    <el-dialog :visible="dialogVisible" center :title=" addType + '签约' " odal-append-to-body append-to-body :close-on-click-modal="false" :before-close="showDomgcloseEditDialog" width="60%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">老师姓名:</div>
        <el-select placeholder="请选择老师" v-model="input1" style="width: 100%" clearable filterable @change="handleChange" :disabled="isDisabled">
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">学生姓名:</div>
        <el-select placeholder="请选择学生姓名" v-model="input2"  style="width: 100%" clearable filterable  :disabled="isDisabled">
          <el-option v-for="item in optionList2" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </div>

      <!-- <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">规划学员:</div>
        <el-select placeholder="请选择规划学员" v-model="input3"  style="width: 100%" clearable filterable  :disabled="isDisabled">
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </div> -->

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">方案名称:</div>
        <el-select placeholder="请选择方案" v-model="input4" style="width: 100%" clearable filterable  :disabled="isDisabled">
          <el-option v-for="item in sourcepeopleList4" :key="item.id" :value="item.id" :label="item.signContractName"></el-option>
        </el-select>
      </div>

      <!-- <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">课时倍数:</div>
        <el-input-number v-model="input5" :precision="2" :step="0.1" :max="100"  :disabled="isDisabled" style="width: 100%"></el-input-number>
      </div> -->

      <div style="display: flex; margin-bottom: 20px; justify-content: center; margin-top: 50px;">
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('关闭')">关闭</el-button>
        <el-button  type="primary" size="small" class="btns" v-if="!isDisabled"  :disabled="isDisabled"  @click="handleClickViewBtn('保存')">保存</el-button>
      </div>

    </el-dialog>



    <div class="header-menu" style="margin-bottom: 50px;">
        <el-form :inline="true" label-width="100px" style="text-align: start;">
          <!-- <el-form-item label="老师姓名:">
            <el-select filterable  clearable class="select" v-model="selseValue1" placeholder="请选择老师姓名" style="width:100%;">
              <el-option v-for="item in sourcepeopleList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线下学员:">
            <el-select class="select" filterable  clearable v-model="selseValue2" placeholder="请选择线下学员 " style="width:100%;">
              <el-option v-for="item in sourcepeopleList2" :key="item.id" :value="item.id" :label="item.realname"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="方案名称:">
            <el-select class="select" filterable  clearable v-model="selseValue4" placeholder="请选择方案名称" style="width:100%;">
              <el-option v-for="item in sourcepeopleList4" :key="item.id" :value="item.id" :label="item.realname"></el-option>
            </el-select>
          </el-form-item> -->
          <el-row>
            <el-col :span="12" :push="12" style="text-align: right;">
              <!-- <el-button @click="handleClearList" class="btns" size="small" icon="el-icon-close">清除</el-button>
              <el-button type="primary" icon="el-icon-search" @click="searchStudent" size="small" class="btns" >搜索</el-button> -->
              <el-button type="primary" @click="addStudent" class="btns" size="small" icon="el-icon-plus">添加</el-button>
            </el-col>
          </el-row>
        </el-form>
    </div>




    <el-table :data="tableData" :stripe="true" :highlight-current-row="true" height="500" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column prop="teacherName" label="老师名称"></el-table-column>
        <el-table-column prop="studentName" label="学生名称"></el-table-column>
        <el-table-column prop="contractName" label="签约方案名称"></el-table-column>
        <!-- <el-table-column prop="hourMultiple" label="课时数倍数"></el-table-column> -->
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作" width="150">
          <template v-slot:default="scope">
            <el-button type="text" :disabled="scope.row.contractType === 1" @click="editById(scope.$index, scope.row,1)">编辑</el-button>
            <el-button type="text" @click="editById(scope.$index, scope.row,2)">删除</el-button>
            <el-button type="text" @click="editById(scope.$index, scope.row,3)">查看</el-button>
          </template>
        </el-table-column>
    </el-table>


    <div style="margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { data } from '../utils/Interceptor';
import { getTeachers, getStudentsType, } from "@/api/fiveClassApi"

export default {
  props: {

  },
  data () {
    return {
      sourcepeopleList1: [],
      sourcepeopleList2: [],
      sourcepeopleList3: [],
      sourcepeopleList4: [],
      inputName: '',
      input: '',
      input1: '',
      input2: '',
      input3: [],
      input4: '',
      input5: 0,
      optionList1: [],
      optionList2: [],
      optionList3: [],
      optionList4: [],
      dialogVisible: false,
      dialogVisible1: false,
      isShowSelect: true,
      tableData:[],

      nodeindex: 0,
      sign_contract_log:[],

      pageNum:1,
      pageSize:10,
      total: 0,

      selseValue1: '',
      selseValue2: '',
      selseValue3: '',
      selseValue4: '',

      addType: '',
      isDisabled:false,
      rowObj: {},
    }
  },
  mounted () {

    getTeachers().then(res => {
      this.optionList1 = res.data
      this.sourcepeopleList1 = res.data
    })

    getStudentsType(1).then(res => {
      this.optionList3 = res.data
      this.sourcepeopleList3 = res.data

      getStudentsType(2).then(res => {
       this.optionList2 = [...res.data,...this.optionList3]
       this.sourcepeopleList2 = [...res.data,...this.sourcepeopleList3]
    })

    })




    axios.get(`${apiBaseUrl}/sign_contract/findByList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
         if(res.data.code === 200){
            if(res.data.data && res.data.data.length > 0){
               this.sourcepeopleList4 = res.data.data
            }else{
              this.sourcepeopleList4 = []
            }
         }else{
           this.sourcepeopleList4 = []
           this.$message.error(res.data.message)
         }
        }).catch(error => {
          this.$message.error(error)
    })

    this.handleGetsign_contract()

  },
  methods: {

    handleClearList () {
      this.selseValue1 = ''
      this.selseValue2 = ''
      this.selseValue3 = ''
      this.selseValue4 = ''
      this.handleGetsign_contract()
    },
    searchStudent () {
      this.handleGetsign_contract()
    },
    addStudent () {
      this.isDisabled = false
      this.addType = '添加'
      this.dialogVisible = true
      this.rowObj.id = ''
      this.input1 = ''
      this.input2 = ''
      this.input4 = ''
      this.input5 = 0
    },


    editById(index,row,type){

      if(type === 1){
        this.rowObj = row
        this.isDisabled = false
        this.dialogVisible = true

        this.input1 = this.rowObj.teacherId
        this.input2 = this.rowObj.studentId
        this.input4 = this.rowObj.contractId
        this.input5 = this.rowObj.hourMultiple ? this.rowObj.hourMultiple : 0

        this.addType = '编辑'
      }

      if(type === 2){
            axios.post(`${apiBaseUrl}/teacher_contract/delete/${row.id}`,{},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                if (res.data.code == 200) {
                  this.handleGetsign_contract()
                } else {
                  this.$message.error(res.data.message)
                }
            }).catch(error => {
              this.$message.error(error)
            })
      }

      if(type === 3){
        this.rowObj = row
        this.dialogVisible = true
        this.isDisabled = true

        this.input1 = this.rowObj.teacherId
        this.input2 = this.rowObj.studentId
        this.input4 = this.rowObj.contractId
        this.input5 = this.rowObj.hourMultiple ? this.rowObj.hourMultiple : 0

        this.addType = '查看'
      }

      console.log(index,row,type)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.handleGetsign_contract()
    },

    handleCurrentChange (v) {
      this.pageNum = v
      this.handleGetsign_contract()
    },

    handleGetsign_contract(){
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.selseValue1,
        studentId: this.selseValue2,
        contractId: this.selseValue4,
      }
      axios.post(`${apiBaseUrl}/teacher_contract/findPage`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
         if(res.data.code === 200){
            this.$message.success(res.data.message)
            this.inputName = res.data.data.signContractName
            if(res.data.data && res.data.data.records.length > 0){
              this.tableData = res.data.data.records
            }else{
              this.tableData = []
            }
         }else{
           this.tableData = []
           this.$message.error(res.data.message)
         }
        }).catch(error => {
          this.$message.error(error)
      })
    },


    handleChange(e){
      console.log(e)
      this.isShowSelect = false
    },
    handleClickViewBtn (type) {
      if (type === '关闭') {
          this.input = ''
          this.input1 = ''
          this.input2 = ''
          this.input3 = []
          this.input4 = ''
          this.input5 = 0
          this.dialogVisible = false
          this.dialogVisible1 = false
      }

      if (type === '保存') {

          let obj = {
              teacherId: this.input1,
              studentId: this.input2,
              contractId: this.input4,
              // hourMultiple: this.input5,
              id: this.rowObj.id,
          }


          let isUrlType = ''
          if(this.addType === '添加'){
              isUrlType = 'teacher_contract/add'
          }

          if(this.addType === '编辑'){
              isUrlType = 'teacher_contract/update'
          }

          axios.post(`${apiBaseUrl}/${isUrlType}`,obj,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
              if (res.data.code == 200) {
                  this.handleGetsign_contract()
                  this.input = ''
                  this.input1 = ''
                  this.input2 = ''
                  this.input3 = []
                  this.input4 = ''
                  this.input5 = 0
                  this.dialogVisible = false
              } else {
                this.$message.error(res.data.message)
              }
          }).catch(error => {
            this.$message.error(error)
          })
      }
    },

    handleAddSubmit(){

        let isUrl = ''
        let obj = { signContractName: '',  List: [], }

        if(this.isAdd  === 1){
            isUrl = 'sign_contract/add'
            obj = {  signContractName: this.inputName, signContractInfoList: this.tableData,  }
        }

        if(this.isAdd  === 2){
            isUrl = 'sign_contract/update'
            obj = {  signContractName: this.inputName, signContractInfoList: this.tableData,  }
        }

        axios.post(`${apiBaseUrl}/` + isUrl, obj,{ headers :{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
            if(res.data.code === 200){
              this.$emit('handleToRetnrn',false)
            }else{
              this.$message.error(res.data.message)
            }
          }).catch(error => {
            console.error(error)
            this.$message.error(error)
        })

    },

    handleToRetnrn(){
      this.$emit('handleToRetnrn',false)
    },

    showDomgcloseEditDialog () {
      this.dialogVisible = false
    },

    showDomgcloseEditDialog1 () {
      this.dialogVisible1 = false
    },
    handleDelet (itme) {
      console.log(itme)
      this.$confirm("确定要删除该条信息吗?, 是否继续?", "提示", { confirmButtonText: "确定",cancelButtonText: "取消",type: "warning", }).then(() => {
        axios.post(`${apiBaseUrl}/sign_contract/deleteInfoById/${itme.id}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if (res.data.code == 200) {
              this.handleGetsign_contract()
            } else {
              this.$message.error(res.data.message)
            }
        }).catch(error => {
          this.$message.error(error)
        })
      }).catch(() => {
        this.$message({type: "warning",message: "已取消",})
      })
    },
    handleEdit (itme) {
      this.dialogVisible = true

      this.input3 = [itme.periodStartDate,itme.periodEndDate]
      console.log(itme)
    },
    handleView (itme) {

      axios.post(`${apiBaseUrl}/sign_contract_log/findPage`,{pageNum:1, pageSize:10000},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.sign_contract_log = res.data.data.records
            } else {
              this.$message.error(res.data.message)
            }
        }).catch(error => {
          this.$message.error(error)
      })

      this.dialogVisible1 = true
      console.log(itme)
    },
    handleAdd (itmeList,index) {
      this.nodeindex = index
      this.dialogVisible = true
      console.log(itmeList)
    },


  }
}
</script>

<style scoped>



.text {
  display: inline-block;
  font-size: 22px;
  border: 1px solid #ccc;
  width: 50px;
  height: 38px;
  border-radius: 5px;
}

@media screen and (max-width: 750px) {
  .ContractPlan {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  .ContractPlan>>>.el-dialog {
    width: 100% !important;
  }

  /* .ContractPlan>.el-dialog>>>.el-dialog {
    width: 100% !important;
  } */
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.is-disabled{
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/NewSigningPlanFiles/TeacherSignedContract.vue